// @flow

import { connect } from "react-redux";

import {
  closeNotification,
  isNotificationOpen,
  notificationReplacements,
  openNotification,
} from "./state";

export const withNotificationTrigger = connect(null, {
  closeNotification,
  openNotification,
});

export const withNotification = connect(
  (state, { id }) => ({
    show: isNotificationOpen(id, state),
    replacements: notificationReplacements(id, state),
  }),
  (dispatch, { id }) => ({
    close: () => dispatch(closeNotification(id)),
    open: () => dispatch(openNotification(id)),
  })
);
